@if (hasDateFilters || hasFilters) {
  <button class="btn-icon inline-flex red" (click)="reset()">
    <mat-icon svgIcon="remove" class="icon-16 margin--right-s red"></mat-icon>
    Fjern alle filtre
  </button>
}
<button
  mat-icon-button
  [color]="hasDateFilters ? 'primary' : ''"
  (click)="showDateFilter()"
  matTooltip="Filtrér på periode for leveringsdato"
  >
  <mat-icon svgIcon="calendar"></mat-icon>
</button>
<button
  mat-icon-button
  [color]="hasFilters ? 'primary' : ''"
  [matMenuTriggerFor]="ordreFilter"
  matTooltip="Brug filtre"
  [matBadge]="filterCount()"
  matBadgeSize="small"
  [matBadgeHidden]="filterCount() === 0"
  [disabled]="isLoading"
  >
  <mat-icon svgIcon="filter"></mat-icon>
</button>

<mat-menu #ordreFilter="matMenu">
  @for (opgave of opgaver; track opgave) {
    <div (click)="$event.stopPropagation()">
      <mat-slide-toggle [checked]="isOpgaveChecked(opgave.id)" color="primary" (change)="onOpgaveToggle(opgave.id)">
        <span>{{ opgave.name }}</span>
      </mat-slide-toggle>
    </div>
  }
  <hr />
  @for (state of serviceOrderStates; track state) {
    <div (click)="$event.stopPropagation()">
      <mat-slide-toggle [checked]="isStateChecked(state.id)" color="primary" (change)="onStateToggle(state.id)">
        <span>{{ state.displayText }}</span>
      </mat-slide-toggle>
    </div>
  }
  <hr />
  @for (product of products; track product) {
    <div (click)="$event.stopPropagation()">
      <mat-slide-toggle [checked]="isProductChecked(product.id)" color="primary" (change)="onProductToggle(product.id)">
        <mat-icon [svgIcon]="product.text.toLowerCase()" [matTooltip]="product.text | titlecase"></mat-icon>
        <span>{{ product.text }}</span>
      </mat-slide-toggle>
    </div>
  }
  <hr />
  <div>
    <mat-slide-toggle [checked]="filter.showParked" color="primary" (change)="onParkedToggle()">Vis parkerede</mat-slide-toggle>
  </div>
  <hr />
  <div (click)="$event.stopPropagation()">
    <app-partner-filter [partners]="partners" [filter]="filter" (partnerChange)="onPartnerChange($event)"></app-partner-filter>
  </div>
</mat-menu>
